import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';

import { useDispatcherApplication } from 'providers/AccessManagementApplication/useDispatcher';
import { useSelectorApplication } from 'providers/AccessManagementApplication/useSelectors';

import Navbar from 'components/Navbar';
import SideNav from 'components/SideNav';

import ROUTES from 'utils/routes';
import './styles.scss';

export function Layout({ children }) {
  const [small, setSmall] = useState(false);
  const hasAutoSelectedApp = useRef(false);
  const { getApplications, selectedApplication } = useDispatcherApplication();
  const { applicationsState, selectedApplicationState } = useSelectorApplication();

  useEffect(() => {
    getApplications();
  }, [getApplications]);

  useEffect(() => {
    const hasCurrentSelection = Boolean(selectedApplicationState.app?.id || selectedApplicationState.app?.sk);

    if (
      !hasAutoSelectedApp.current &&
      applicationsState.loaded &&
      applicationsState.list.length &&
      !hasCurrentSelection
    ) {
      const firstApp = applicationsState.list[0];
      selectedApplication({
        ...firstApp,
        id: firstApp.id || firstApp.sk,
      });
      hasAutoSelectedApp.current = true;
    }
  }, [applicationsState.loaded, applicationsState.list, selectedApplication, selectedApplicationState.app]);

  const renderContent = () => {
    let totalApps = [];
    if (applicationsState.loaded && applicationsState.list.length) {
      totalApps = applicationsState.list.map(app => ({
        ...app,
        id: app.id || app.sk,
        sk: app.sk || app.id,
        to: ROUTES.ACCESS_MANAGEMENT,
        application: app.name,
        hasPermission: true,
      }));

      return <SideNav key="sideNav" small={small} content={totalApps} />;
    } else {
      return <SideNav key="sideNav" small={small} content={totalApps} />;
    }
  };

  return (
    <>
      <Navbar title="Role-Based Permissions" onSmall={() => setSmall(!small)} />
      <div className="app-container">
        {renderContent()}

        <div className={clsx('contentPage', { contentPageSmall: small })}>
          <main className="main-container">{children}</main>
        </div>
      </div>
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
